<template>
  <v-list-item
    link
    @click="select"
    :dark="selected"
    :class="selected ? 'selected my-1' : ''"
  >
    <v-list-item-title>{{
      simpleItem ? item : item[itemText]
    }}</v-list-item-title>
  </v-list-item>
</template>

<script>
export default {
  name: "SelectItem",
  props: {
    item: {
      required: true
    },
    itemText: {
      type: String,
      default: "name"
    },
    itemKey: {
      type: String,
      default: "id"
    },
    selected: {
      type: Boolean,
      required: true
    },
    simpleItem: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    select() {
      this.$emit(
        "change",
        this.simpleItem ? this.item : this.item[this.itemKey]
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.selected {
  cursor: pointer;
  border-radius: 4px;
  background-color: #ffb300 !important;
}
</style>
